const swiper = new Swiper('.yrityskaruselli .swiper.kuvakaruselli.enabled', {
    // Optional parameters
    //direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // If we need pagination
/*     pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }, */

/*     // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }, */

/*     // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    }, */
  });
